var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"breadcrumb-demo"}},[_c('breadcrumb-default'),_c('breadcrumb-color'),_c('breadcrumb-separator'),_c('breadcrumb-slot'),_c('breadcrumb-alignment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }